import { NgModule } from '@angular/core';
import { SharedModule } from '@dash/randy/shared/shared.module';
import { LoginComponent } from './pages/account/login/login.component';
import { SecurityModule } from '@dash/randy/security/security.module';
import { SelectApplicationComponent } from './pages/account/select-application/select-application.component';
import { RouterModule } from '@angular/router';
import {MatCardModule} from "@angular/material/card";
import {MatButton, MatIconButton} from "@angular/material/button";
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [LoginComponent, SelectApplicationComponent],
  imports: [SharedModule, SecurityModule, RouterModule, MatCardModule, MatIconButton, MatButton, MatInputModule],
})
export class AuthorizationModule {}
